import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

export const importEmployees = async (token: string, file: any, companyId: number, permission: string | null,) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axios.post(`${API_URL}/import/employees/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `${token}`,
        },
        permission,
    } as CustomAxiosRequestConfig);
    return res.data;
};



type TemplateFormat = "csv" | "xlsx";

export const downloadTemplate = async (
  token: string,
  format: TemplateFormat = "csv"
): Promise<void> => {
  const isExcel = format === "xlsx";

  const response = await axios.get(
    `${API_URL}/import/template/employee/`,
    {
      headers: {
        Authorization: token,
        Accept: isExcel
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "text/csv",
      },
      params: {
        format,
      },
      responseType: "blob",
    }
  );

  const mimeType = isExcel
    ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    : "text/csv;charset=utf-8";

  const blob = new Blob([response.data], {
    type: mimeType,
  });

  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");

  anchor.href = url;
  anchor.download = `template_employee.${format}`;

  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  window.URL.revokeObjectURL(url);
};


export const fetchImportInstructions = async (token: string, entity: string, permission: string | null) => {
    const res = await axios.get(`${API_URL}/import/instructions/${entity}/`, {
        headers: {
            Authorization: `${token}`,
        },
        permission,
    } as CustomAxiosRequestConfig);
    return res.data;
};

export const downloadReferenceData = async (token: string, entity: string, field: string) => {
    const res = await axios.get(`${API_URL}/import/data/${entity}/${field}/`, {
        headers: {
            Authorization: `${token}`,
            Accept: 'text/csv',
        },
        responseType: 'blob',
    });

    const disposition = res.headers['content-disposition'] || '';
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    const filename = match ? match[1] : `dati_${entity}_${field}.csv`;

    const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = blobUrl;
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(blobUrl);
};